var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerGameTypeEur(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a9 9 0 110 18 9 9 0 010-18zm1.118 3.44c-.62 0-1.187.09-1.7.27-.507.181-.95.452-1.325.813-.371.362-.66.811-.864 1.348-.168.447-.262.957-.29 1.53H7.662v1.004h1.267v.96H7.661v1.003h1.273c.013.633.109 1.192.295 1.677.205.518.49.953.856 1.304.367.347.799.608 1.297.784a4.987 4.987 0 001.655.264c.317 0 .63-.02.938-.06.307-.038.603-.092.886-.16l-.213-1.465a4.09 4.09 0 01-.71.176c-.249.039-.505.058-.77.058-.36 0-.69-.051-.988-.153a1.931 1.931 0 01-.754-.477c-.21-.22-.374-.5-.49-.842-.102-.311-.155-.68-.165-1.106h2.618v-1.003h-2.622v-.96h2.622v-1.003h-2.614c.02-.359.07-.676.153-.952a2.24 2.24 0 01.483-.872c.21-.23.464-.4.762-.513a2.91 2.91 0 011.018-.168 4.622 4.622 0 011.458.242l.212-1.472a8.943 8.943 0 00-.864-.162 5.727 5.727 0 00-.88-.066z",
    fill: "currentColor"
  })));
}
SvgPokerGameTypeEur.displayName = 'PokerGameTypeEur';
export default SvgPokerGameTypeEur;